const Index = () => import('./index.vue');

export default [
    {
        path: '/gl-accounts-setup',
        component: Index
    }
]